import React from 'react';
import { NoPermission } from './NoPermission';

export const withAuth = (Component: React.ComponentType) => {
  return function AuthenticatedComponent(props: { isAuthenticated: boolean }) {
    const { isAuthenticated, ...componentProps } = props;
    if (isAuthenticated) {
      return <Component {...componentProps} />;
    }

    return <NoPermission />;
  };
};
